import React from 'react';
import { HeroVariant74 } from '../components/HeroVariant74';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage74() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1810">
      <Navigation data-id="element-1811" />
      <main data-id="element-1812">
        <HeroVariant74 data-id="element-1813" />
        <WhyUs data-id="element-1814" />
        <Services data-id="element-1815" />
        <FAQ data-id="element-1816" />
        <Testimonials data-id="element-1817" />
        <Consultation data-id="element-1818" />
      </main>
      <Footer data-id="element-1819" />
      <CookieBanner data-id="element-1820" />
      <FloatingContact data-id="element-1821" />
    </div>;
}